import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=38e88620&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e88620",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38e88620')) {
      api.createRecord('38e88620', component.options)
    } else {
      api.reload('38e88620', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=38e88620&scoped=true&", function () {
      api.rerender('38e88620', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iKS9SamMT0Xa/JS/comp/Accordion.vue"
export default component.exports